import React, { useState, useEffect } from 'react';
import {
  Grid, Box, Typography, TextField, Paper, FormControl, InputLabel, Select, MenuItem,
  Button, Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from '../axiosInstance';
import eBrary_Logo from '../assets/Logoa.png';

const ProfilePage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const [profile, setProfile] = useState({
    username: '',
    email: '',
    mobile: '',
    displayname: '',
    role: 'Student'
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError("Session expired. Please log in again.");
        navigate('/LoginPage');
        return;
      }
  
      try {
        const res = await axios.get('https://backend.scholarkart.in/api/user/me', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setProfile(prev => ({ ...prev, ...res.data }));
      } catch (err) {
        if (err.response?.data?.msg?.includes('jwt expired')) {
          setError("Session expired. Redirecting to login...");
          localStorage.removeItem('token');
          setTimeout(() => navigate('/LoginPage'), 2000);
        } else {
          setError('Failed to load user profile.');
        }
      }
    };
  
    fetchUser();
  }, []);
  
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put('https://backend.scholarkart.in/api/update-profile', profile, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage('Profile updated successfully!');

    // ✅ Redirect after short delay
    setTimeout(() => {
      navigate('/mycourse');
    }, 1500);

    } catch (err) {
      setMessage('Error updating profile.');
    }
  };

  return (
      <Grid
        container
        sx={{
          height: '100vh',
          width: '100vw',
        }}
      >
      {/* Left Panel */}
        <Grid 
          item 
          sx={{
            width: {
              xs: '100%',  // 100% on mobile (xs = 0px and up)
              md: '50%',   // 50% on desktop (md = 900px and up)
            }
          }} 
          component={Paper} 
          elevation={6} 
          square
        >
        <Box display="flex" flexDirection="column" alignItems="center">
          <img src={eBrary_Logo} alt="eBrary Logo" style={{ height: 60 }} />
          <Typography component="h1" variant="h5" sx={{ fontWeight: 'bold', textAlign: 'center', textShadow: '1px 1px 3px rgba(0,0,0,0.3)' }}>
            Transformation of eBrary and eLearning experience.
          </Typography>
        </Box>

                          <Box
                            sx={{
                              mx: 8,
                              my: 2,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
          <Typography variant="h5" fontWeight="bold">Update Your Profile</Typography>
          {error && <Alert severity="error">{error}</Alert>}
          {message && <Alert severity="info" sx={{ mt: 2 }}>{message}</Alert>}

          <Box component="form" onSubmit={handleSubmit} mt={2}>
            <TextField
              label="Username"
              name="username"
              fullWidth
              margin="normal"
              value={profile.username}
              onChange={handleChange}
            />

            <TextField
              label="Email"
              name="email"
              fullWidth
              margin="normal"
              value={profile.email}
              onChange={handleChange}
              disabled
            />

            <TextField
              label="Mobile Number"
              name="mobile"
              fullWidth
              margin="normal"
              value={profile.mobile}
              onChange={handleChange}
            />

            <TextField
              label="Display Name"
              name="displayname"
              fullWidth
              margin="normal"
              value={profile.displayname}
              onChange={handleChange}
            />

            <FormControl fullWidth margin="normal">
              <InputLabel id="role-label">Role</InputLabel>
              <Select
                labelId="role-label"
                name="role"
                value={profile.role}
                onChange={handleChange}
                label="Role"
              >
                <MenuItem value="Student">Student</MenuItem>
                <MenuItem value="Faculty">Faculty</MenuItem>
                <MenuItem value="Librarian">Librarian</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, background: 'linear-gradient(to right, rgb(7, 67, 197), rgb(11, 2, 114))' }}
            >
              Save Profile
            </Button>

            <Box textAlign="center" mt={2}>
              <Typography variant="body2">
                No change?
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => navigate('/LoginPage')}
                  sx={{
                    ml: 1,
                    borderColor: 'rgb(11, 2, 114)',
                    color: 'rgb(11, 2, 114)',
                    fontWeight: 'bold'
                  }}
                >
                  Return to eBrary
                </Button>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>

      {/* Right Panel */}
    <Grid
      item
      sx={{
        width: '50%',
        background: 'linear-gradient(to right,rgb(11, 2, 114),rgb(7, 67, 197))',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: 6,
        display: { xs: 'none', md: 'flex' }
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Your education, your way. Access courses, anytime, anywhere.
      </Typography>
      <Typography variant="body1">
        Welcome to Sva Learn - the ultimate destination for seamless learning and exploration! Access Lesson Notes, Takeaways, Flash Cards, Mind Maps, Quizzes and AI Chatbot.
      </Typography>
    </Grid>
    </Grid>
  );
};

export default ProfilePage;
